import { render } from "./PDFPageRender.vue?vue&type=template&id=79664c8b&ts=true"
import script from "./PDFPageRender.vue?vue&type=script&lang=ts"
export * from "./PDFPageRender.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__